/**
 * Partner Program Terms Content
 * Edit this file to update the partner terms displayed on the /partner-terms page.
 * Each section has a title and content (supports multiple paragraphs).
 */

export const partnerTermsContent = {
  lastUpdated: 'January 2025',
  companyName: 'Bandos',

  sections: [
    {
      title: '1. Program Overview',
      content: [
        "The Partner Program allows approved partners to earn recurring commission for referring paying customers to the Company's software platform. Participation is subject to approval and ongoing compliance with these terms.",
      ],
    },
    {
      title: '2. Independent Partner Relationship',
      content: [
        'The Partner acts as an independent contractor. Nothing in this agreement creates employment, agency, franchise, or joint venture status. The Partner may not represent themselves as an employee, agent, or official representative of the Company.',
        'The Partner is solely responsible for their own taxes, reporting, and legal obligations in their jurisdiction.',
      ],
    },
    {
      title: '3. Eligibility and Approval',
      content: [
        'All Partners must be approved by the Company. The Company may accept or reject any application at its sole discretion.',
      ],
    },
    {
      title: '4. Referral Attribution',
      content: [
        '4.1 Method: Referrals are tracked primarily through unique referral codes issued to each Partner. The Company may also consider other objective evidence at its discretion.',
        "4.2 Attribution Window: A referral is valid if a prospective customer uses a Partner's referral code within thirty (30) days before creating a paid subscription.",
        '4.3 First Referrer Rule: Attribution follows a "first valid referrer wins" model. The first Partner to drive a qualifying tracked interaction within the attribution window owns the customer for commission purposes.',
        "4.4 Trials: If a user starts a trial without a referral but applies a Partner's referral code before converting to a paid subscription within the 30-day window, the Partner receives attribution.",
        "4.5 Conflicting Claims: If multiple Partners claim the same customer, the Company will determine attribution at its sole discretion based on available evidence. The Company's decision is final.",
      ],
    },
    {
      title: '5. Commission Structure',
      content: [
        '5.1 Rate: The Partner earns an agreed percentage of net subscription revenue actually received by the Company from referred customers.',
        '5.2 Duration: Commission is paid for as long as the referred customer maintains an active paid subscription.',
        '5.3 Scope: Commission applies to all subscription plans and future upgrades made by the referred customer.',
        '5.4 Adjustments: No commission is paid on refunded payments, chargebacks, fraudulent transactions, or unpaid invoices. Previously credited commission may be reversed in such cases.',
      ],
    },
    {
      title: '6. Payments',
      content: [
        '6.1 Schedule: Commissions are calculated monthly and paid monthly in arrears.',
        '6.2 Approval Period: Commission becomes payable no earlier than thirty (30) days after the customer payment is received, to allow for refunds and disputes.',
        "6.3 Minimum Threshold: Payments are only issued once the Partner's approved unpaid balance reaches at least USD 50. Unpaid balances roll over to future periods.",
        '6.4 Method: Payments are made via Stripe or another method chosen by the Company. Partners are responsible for providing accurate payout details.',
        '6.5 Invoicing: The Company is not required to receive invoices from the Partner unless otherwise required by law.',
      ],
    },
    {
      title: '7. Customer Relationship',
      content: [
        'All referred customers are customers of the Company, not of the Partner. The Company retains full control over pricing, support, contracts, and account management.',
        'Partners may not provide official support or make binding promises on behalf of the Company. The Company may communicate directly with all customers at any time.',
      ],
    },
    {
      title: '8. Marketing Rules and Restrictions',
      content: [
        '8.1 Permitted Promotion: Partners may promote the Service using approved branding and materials.',
        "8.2 Brand Bidding Prohibition: Partners may not bid on the Company's brand name, trademarks, or confusingly similar terms in paid search advertising.",
        '8.3 Conduct Requirements: Partners may not engage in spam, unsolicited bulk messaging, misleading claims, impersonation, deceptive marketing, or any illegal promotional activity.',
        '8.4 Representation: Partners must clearly present themselves as independent and may not imply official partnership beyond participation in this program.',
        '8.5 Competitors: Partners may promote competing products.',
        '8.6 Discount Codes: Partners may use or distribute Company-approved discount codes only.',
      ],
    },
    {
      title: '9. Brand Usage',
      content: [
        "The Company grants Partners a limited, revocable, non-exclusive right to use the Company's name and logo solely for promoting the Service. This right may be withdrawn at any time.",
      ],
    },
    {
      title: '10. Fraud and Abuse',
      content: [
        'The Company may withhold or cancel commissions in cases of suspected fraud, self-referrals, abuse, or violations of these terms.',
        'Partners may not create accounts for themselves or their own organizations using their referral code. The Company may cancel customers obtained through deceptive or unlawful means.',
      ],
    },
    {
      title: '11. Changes to the Program',
      content: [
        'The Company may modify commission rates or program terms at any time. Changes will not retroactively reduce commission already earned, but may apply to future referrals.',
      ],
    },
    {
      title: '12. Termination',
      content: [
        '12.1 By Either Party: Either party may terminate participation at any time.',
        '12.2 Effect of Termination: Partners will be paid approved, earned commission up to the termination date, provided no breach has occurred.',
        '12.3 Termination for Breach: If the Partner violates these terms, the Company may immediately terminate the agreement and cancel all future commission, including on previously referred customers.',
      ],
    },
    {
      title: '13. Limitation of Liability',
      content: [
        'The Company provides the Partner Program "as is" and makes no guarantees regarding income or performance. The Company is not liable for indirect or consequential losses.',
      ],
    },
    {
      title: '14. Governing Law and Jurisdiction',
      content: [
        'These terms are governed by the laws of Norway. Any disputes shall be resolved in Norwegian courts.',
      ],
    },
  ],
}
